// extracted by mini-css-extract-plugin
module.exports = {"root":"u-flowable-link_edit_21Lvv9jM"};